var map = {
	"./colors.vue": "fac3",
	"./iconography.vue": "77da",
	"./illustration.vue": "6259",
	"./imagery.vue": "2923",
	"./infographic.vue": "2990",
	"./key-visuals.vue": "44b0",
	"./logos.vue": "1aa9",
	"./mascot.vue": "4629",
	"./motion.vue": "3e80",
	"./typography.vue": "09f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "91a6";